/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.27/esri/copyright.txt for details.
*/
const o=3,t=3,c=10;export{c as PATH_NUM_CIRCLE_PROFILE_SUBDIVISIONS,t as PATH_NUM_ROUND_CAP_EXTRUSION_SUBDIVISIONS,o as PATH_NUM_ROUND_JOIN_SUBDIVISIONS};
